export default __webpack_public_path__ + "static/media/coral.ff630484.svg";